import React from "react";
import { CheckCircle2 } from "lucide-react";

export const FormInput = ({ label, icon: Icon, error, touched, isAutoFilled, ...props }) => (
  <div className="mb-4 md:mb-5 group w-full">
    <div className="flex justify-between items-center mb-1">
      <label className="text-[9px] md:text-[10px] font-bold uppercase tracking-widest text-slate-400 ml-1">
        {label}
      </label>
      {touched && error && (
        <span className="text-[9px] font-bold text-rose-500 animate-in fade-in">{error}</span>
      )}
    </div>
    <div className={`relative flex items-center rounded-xl md:rounded-2xl transition-all duration-500 border-2
      ${touched && error ? "bg-rose-50/30 border-rose-100" : isAutoFilled ? "bg-emerald-50/40 border-emerald-200/50 shadow-sm" : "bg-slate-50 border-slate-50 focus-within:bg-white focus-within:border-emerald-500/30"}`}>
      <div className={`pl-4 ${touched && error ? "text-rose-400" : isAutoFilled ? "text-emerald-500" : "text-slate-400 group-focus-within:text-emerald-500"}`}>
        {Icon && <Icon size={16} />}
      </div>
      <input
        {...props}
        className="w-full bg-transparent px-3 py-3 md:py-4 text-sm font-semibold outline-none text-slate-700 placeholder:text-slate-300"
      />
      {isAutoFilled && (
        <div className="pr-4 text-emerald-500 animate-in zoom-in duration-500">
          <CheckCircle2 size={14} />
        </div>
      )}
    </div>
  </div>
);